<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <v-btn @click="goBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
            Назад
          </v-btn>
        </v-col>
        <v-col cols="12">
          Печатная форма
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div class="mb-4">
        <v-btn @click="print()" color="primary">
          <v-icon>
            mdi-printer
          </v-icon>
          Печать
        </v-btn>
        <v-btn @click="print('xlsx')" color="success" class="mx-4">
          <v-icon>
            mdi-microsoft-excel
          </v-icon>
          Excel
        </v-btn>
      </div>
      <iframe :src="jasperPath" width="100%" height="600px" sandbox>
      </iframe>
    </v-card-text>
  </v-card>
</template>
<script>


export default {
  name: 'PurchaseDetail',
  data () {
    return {
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    getOrderId () {
      return this.$route.params.id
    },
    jasperPath () {
      return `http://185.146.3.86:8081/jasperserver/rest_v2/reports/altercar/Zakaz_naryad.pdf?id=${this.getOrderId}&username=jasperadmin&password=jasperadmin`
    }
  },
  methods: {
    print (format) {
      let url = this.jasperPath
      if (format === 'xlsx') {
        url = url.replace('pdf', format)
      }
      window.open(url, '_blank')
    },
    goBack () {
      this.$router.go(-1);
    },
    async getData () {
      try {
        await this.$store.dispatch('partnerPurchaseOrder/getPurchaseOrderById', this.getOrderId)
      } catch (e) {
        console.log('error', e);
      }
    },
  }
}
</script>
<style scoped>

</style>